import { AddDamagedPersonParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postAddDamagedPerson/addDamagedPersonQuery.type';
import { addDamagedPersonQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postAddDamagedPerson/addDamagedPersonQueryFunction';

export const addDamagedPersonQuery = () => {
  return {
    mutationKey: ['addDamagedPerson'],
    mutationFn: (params: AddDamagedPersonParamsType) =>
      addDamagedPersonQueryFunction(params),
  };
};
